import { logout } from '@/features/auth';
import type { State } from '@/reducers/types';
import { createSlice } from '@reduxjs/toolkit';

interface SemState {
  isRegenerated?: boolean;
  title?: string;
}

const initialState: SemState = {
  isRegenerated: undefined,
  title: undefined,
};

const { name, reducer, actions } = createSlice({
  name: 'sem',
  initialState,
  reducers: {
    setIsRegenerated(state, action) {
      state.isRegenerated = action.payload as boolean | undefined;
    },
    setTitle(state, action) {
      state.title = action.payload as string | undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout.fulfilled, () => initialState);
  },
});

const { setIsRegenerated, setTitle } = actions;

export { name, reducer, setIsRegenerated, setTitle };

export const selectSemIsRegenerated = (state: State) => state[name].isRegenerated;
export const selectSemTitle = (state: State) => state[name].title;
